import { createUseEntryPointContext } from '@atlassian/jira-entry-point';
import type { versionsPanelEntryPoint } from '@atlassian/jira-software-version-backlog-panel-relay/entrypoint';

export const VersionPanelEntrypointContext =
	createUseEntryPointContext<typeof versionsPanelEntryPoint>();
